// extracted by mini-css-extract-plugin
export var videoContainer = "_jr-0";
export var videoIframe = "_jr-3";
export var videoLink = "_jr-1";
export var videoOverlay = "_jr-4";
export var videoOverlayText = "_jr-5";
export var videoWrapper = "_jr-2";